import { render, staticRenderFns } from "./PartOrderDetails.vue?vue&type=template&id=3b7766bc&"
import script from "./PartOrderDetails.vue?vue&type=script&lang=js&"
export * from "./PartOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports